import $ from 'jquery';

const determineActivePage = () => {
  const menuItems = $('[data-js=determine-active]');

  let currentPath;
  if (typeof window !== 'undefined') {
    currentPath = window.location.pathname;
  }

  if (menuItems.length > 0) {
    for (const item of menuItems) {
      const itemLink = $(item).find('a').attr('href');
      if (currentPath && currentPath.includes(itemLink)) {
        const itemClass = $(item).attr('class');
        $(item).addClass(itemClass + '--active');
      }
    }
  }
}

export default determineActivePage;
